import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.TEAM_CREATE_SUCCESS, createdTeam: data.team });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.TEAM_CREATE_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const createTeam = (data) => {
  return async (dispatch) => {
    dispatch({ type: CONST.TEAM_CREATE_REQUEST });

    axios.post('/teams', data).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
